import { useCallback, useEffect, useMemo, useState } from "react"
import styles from './index.module.scss'
import {LoadingOutlined} from '@ant-design/icons'
import * as _ from "underscore";
import { Button, Radio, Space, message } from "antd";
import API, { commonApiInvoker } from "@api/api";
import PSAIModal from "@PSAIComponents/PSAIModal";

const ExtraRender = (props) => {
    const {current, total, labels, getLabels, imageId, deliveryId, defaultPass, defaultDisabled, defaultCancel} = props
    const [pass, setPass] = useState(defaultPass)
    const [cancel, setCancel] = useState(defaultCancel)
    const [loading, setLoading] = useState(false)

    const supportPreviousAndNext = useMemo(() => {
        return props.onPrevious && props.onNext
    }, [props.onPrevious, props.onNext])

    // 上一张
    const handlePre = () => {
        if (current == 0) return
        props.onPrevious()
    }

    // 下一张
    const handleNext = () => {
        if (cancel) {
            if(current + 1 < total) {
                props.onNext(false, true)
            } else {
                props.onClose()
            }
            return false
        }
        if (pass == null) {
            message.warning('请选择是否通过')
            return false
        }
        // 尝试解决macOS标注提交问题
        let labels = getLabels()
        if (!pass && labels.length == 0) {
            message.warning('选择不通过，请提供标注信息！')
            return false
        }
        if (!pass && labels.some(item => item.time || item.time == 0) && labels.some(item => !item.label)) {
            message.warning('选择不通过，请提供视频标注信息！')
            return false
        }
        if (pass && labels.length > 0) {
            PSAIModal.confirm({
                title: '是否确定将该图像标记为通过',
                okText: '通过',
                cancelText: '不通过',
                onOk () {
                    setLoading(true)
                    return commonApiInvoker(API.merchantJudge({
                        deliveryId: deliveryId,
                        imageId: imageId,
                        pass: true,
                        annotations: '',
                    }), setLoading, false).then(() => {
                        if(current + 1 < total) {
                            props.onNext(true)
                        } else {
                            props.onClose()
                        }
                    })
                },
                onCancel () {
                    setLoading(true)
                    return commonApiInvoker(API.merchantJudge({
                        deliveryId: deliveryId,
                        imageId: imageId,
                        pass: false,
                        annotations: labels,
                    }), setLoading, false).then(() => {
                        if(current + 1 < total) {
                            props.onNext(false)
                        } else {
                            props.onClose()
                        }
                    })
                },
                onClose () {}
            })
            return false
        }
        setLoading(true)
        commonApiInvoker(API.merchantJudge({
            deliveryId: deliveryId,
            imageId: imageId,
            pass: pass,
            annotations: pass? '': labels,
        }), setLoading, false).then(() => {
            if(current + 1 < total) {
                props.onNext(pass)
            } else {
                props.onClose()
            }
        })
    }

    // 确认
    const handleSubmit = () => {
        if (cancel) {
            props.onOk(false, true)
            return false
        }
        // 尝试解决macOS标注提交问题
        let labels = getLabels()
        if (!pass && labels.length == 0) {
            message.warning("选择不通过，请提供标注信息！")
            return false
        }
        if (!pass && labels.some(item => item.time || item.time == 0) && labels.some(item => !item.label)) {
            message.warning('选择不通过，请提供视频标注信息！')
            return false
        }
        setLoading(true)
        commonApiInvoker(API.merchantJudge({
            deliveryId: deliveryId,
            imageId: imageId,
            pass: pass,
            annotations: pass? '': labels,
        }), setLoading, false).then(() => {
            message.success("已提交确认")
            props.onOk(pass)
        })
    }

    const handlePassChange = useCallback((e) => {
        setPass(e.target.value)
        setCancel(false)
    }, [setPass, setCancel])

    return (
        <div className={styles.ExtraRender}>
            <Radio.Group onChange={handlePassChange} value={pass} disabled={defaultDisabled}>
                <Radio style={{ marginRight: '20px' }} value={true}>通过</Radio>
                <Radio value={false}>不通过</Radio>
            </Radio.Group>
            {
                supportPreviousAndNext ?
                <>
                <Space>
                    <Button style={{ marginRight: '10px' }} onClick={handlePre} disabled={current == 0}>
                        上一张
                    </Button>
                    <Button type="primary" loading={loading} onClick={handleNext}>
                        {current + 1 == total ? '完成': '确认，下一张'}
                    </Button>
                    <div style={{marginLeft: 20}}>
                        <span style={{fontSize:"16px",lineHeight:"24px",fontWeight:500}}>{current + 1}</span>
                        <span style={{fontSize:"16px",lineHeight:"24px",fontWeight:500}}> / </span>
                        <span style={{fontSize:"12px",lineHeight:"18px"}}>{total}</span>
                    </div>
                </Space>
                </> : null
            }
            {
                !supportPreviousAndNext && !defaultDisabled ?
                <Button type="primary" loading={loading} onClick={handleSubmit} style={{width: 120}}>
                    确认
                </Button> : null
            }
        </div>
    )
}

export default ExtraRender